import { truncate } from './commonUtil';

export const truncateFilter = function(text, length, clamp = '...') {
  let node = document.createElement('div');
  node.innerHTML = text;
  const content = node.textContent;

  return truncate(content, length, clamp);
};
